export { Center, ICenterProps } from 'native-base';
